import React, {Fragment} from "react";
import {withRouter} from "react-router";
import CustomerService from "../../services/CustomerService";
import RegistrationHeaderService from "../../services/RegistrationHeaderService";
import CustomerLimitService from "../../services/CustomerLimitService";
import TransactionService from "../../services/TransactionService";
import ToastHelper from "../../utils/ToastHelper";
import {Button} from "react-bootstrap";
import RegistrationStatusBadgeComponent from "../../components/RegistrationStatusBadgeComponent";
import Registration from "../../domain/Registration";
import {Card, CardBody, CardDeck, CardHeader, Modal, ModalBody, ModalHeader} from "reactstrap";
import CardDataComponent from "../../components/CardDataComponent";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import DropdownComponent from "../../components/DropdownComponent";
import TransactionCardDataComponent from "../../components/TransactionCardDataComponent";
import BeneficiaryCardDataComponent from "../../components/BeneficiaryCardDataComponent";
import UserSessionService from "../../services/UserSessionService";
import AgentPrivilege from "../../enum/AgentPrivilege";
import CustomerLimitIncreaseRequestComponent from "../../components/CustomerLimitIncreaseRequestComponent";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import TransactionCreation from "../Transaction/TransactionCreation";
import BeneficiaryTransactionCreation from "../Beneficiary/BeneficiaryTransactionCreation";
import IssueBankCardComponent from "../../components/IssueBankCardComponent";
import * as RegistrationStatus from "../../domain/Registration/RegistrationStatus";
import RequestBankAccountComponent from "../../components/RequestBankAccountComponent";
import ChatFromWithInContext from "../../components/chat/ChatFromWithInContext";
import AdminBankAccountService from "../../services/admin/AdminBankAccountService";
import "../../scss/CustomerIndex.css"

const CUSTOMER_CONFIG = [
    {
        dataField: "firstName",
        label: "First Name"
    },
    {
        dataField: "lastName",
        label: "Last Name"
    }
];

const CUSTOMER_LIMIT_CONFIG = [
    {
        dataField: "dailyLimit",
        label: "Daily Limit"
    },
    {
        dataField: "monthlyLimit",
        label: "Monthly Limit"
    }
];

const CUSTOMER_VIEW = "view";
const CUSTOMER_LIMIT_VIEW = "limit";
const TRANSACTION_VIEW = "transactions";
const BENEFICIARY_VIEW = "beneficiaries";

const CUSTOMER_VIEW_DROPDOWN_OPTIONS = [
    {id: "1", name: "Customer", view: CUSTOMER_VIEW},
    {id: "2", name: "Customer Limit", view: CUSTOMER_LIMIT_VIEW},
    {id: "3", name: "Transactions", view: TRANSACTION_VIEW},
    {id: "4", name: "Beneficiaries", view: BENEFICIARY_VIEW}
];

class CustomerIndex extends React.Component {

    constructor(props) {
        super(props);

        this.agentId = UserSessionService.getUser().user.id;
        this.agentOrganisationId = UserSessionService.getUser().user.organisationId;
        this.organisationsCanTransactIds = process.env.REACT_APP_ORGANISATIONS_CAN_TRANSACT_IDS;
        this.organisationsCanTransactIdsArray = this.organisationsCanTransactIds.split(",");
        this.organisationsCanTransactIdsArrayIncludesAgentOrganisation = this.organisationsCanTransactIdsArray.includes(this.agentOrganisationId + '')

        this.baseUrl = "/customer/" + this.props.match.params.registrationId;

        this.props.changeHeader("Customers");

        let viewMode = this.props.match.params.view || CUSTOMER_VIEW;

        this.agentCanViewCustomerLimits = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_CUSTOMER_LIMIT_VIEW);
        this.agentCanRequestCustomerLimitIncrease = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_CUSTOMER_LIMIT_EDIT);
        this.agentCanViewCustomerBeneficiaries = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_BENEFICIARY_VIEW);
        this.agentCanViewCustomerTransactions = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_OUTBOUND_TRANSACTION_VIEW);
        this.agentCanCreateTransactions = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_OUTBOUND_TRANSACTION_CREATE);
        this.agentCanIssueBankCards = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_LINK_BANK_CARD_TO_BANK_ACCOUNT);
        this.agentCanIssueBankAccounts = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_BANK_ACCOUNT_REQUEST);
        this.agentCanChat = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_REGISTRATION_CHAT_CREATE) && !this.organisationsCanTransactIdsArrayIncludesAgentOrganisation;

        this.state = {
            viewMode: viewMode,
            viewModeId: 1,
            customer: null,
            registrationId: this.props.match.params.registrationId,
            registration: null,
            customerLimit: null,
            transactions: [],
            beneficiaries: [],
            isLoading: true,
            isRequestingLimitIncrease: false,
            isCreatingTransaction: false,
            isCreatingTransactionForExistingBeneficiary: false,
            transactionForBeneficiary: {},
            isRegistrationApproved: false,
            showRequestBankAccountModal: false,
            canTransactForCustomer: true,
            canChatForCustomer:false,
            agentOrganisationCanTransact: false
        };

        this.changeViewMode = this.changeViewMode.bind(this);
        this.toggleTransactionForBeneficiaryModal = this.toggleTransactionForBeneficiaryModal.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        if (this.state.registrationId) {
            this.setState({
                isLoading: true
            }, () => this.retrieveCustomerByRegistrationId());
        }
    }

    retrieveCustomerByRegistrationId() {
        CustomerService.retrieveCustomerByRegistrationId(this.state.registrationId).then(response => {
            if (response.registrationId) {
                this.retrieveRegistrationData(response);
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    requestLimitIncrease() {
        this.setState({
            isRequestingLimitIncrease: true
        });
    }

    issueBankCardToCustomer() {
        this.setState({
            showIssueBankCardToCustomerModal: true
        });
    }

    requestBankAccount() {
        this.setState({
            showRequestBankAccountModal: true
        });
    }

    retrieveRegistrationData(customer) {

        let promiseArr = [];

        let customerData = customer;

        promiseArr.push(RegistrationHeaderService.retrieveRegistration(this.state.registrationId));
        promiseArr.push(CustomerLimitService.retrieveCustomerLimit(this.state.registrationId));
        promiseArr.push(TransactionService.retrieveTransactionsByRegistrationId(this.state.registrationId));
        promiseArr.push(AdminBankAccountService.retrieveActiveBankAccount(this.state.registrationId));

        Promise.all(promiseArr).then(response => {

            customerData.registrationType = response[0].registrationType;

            let newState = {};
            let registration = response[0];

            newState.registration = registration;
            newState.customerLimit = response[1];
            newState.transactions = response[2];
            newState.customer = customerData;
            newState.isLoading = false;
            newState.isRegistrationApproved = (
                response[0].registrationStatus === RegistrationStatus.APPROVED ||
                response[0].registrationStatus === RegistrationStatus.PENDING_UPDATE
            );

            let bankAccountResponse = response[3];
            if (bankAccountResponse.accountStatus) {
                newState.bankAccount = bankAccountResponse
            }

            newState.canTransactForCustomer = ((registration.creationAgentId === this.agentId) || (registration.organisationId === this.agentOrganisationId && this.organisationsCanTransactIdsArrayIncludesAgentOrganisation));
            newState.canChatForCustomer = ((registration.commissionAgentId === this.agentId) || (registration.organisationId === this.agentOrganisationId && this.organisationsCanTransactIdsArrayIncludesAgentOrganisation));

            if (!newState.isRegistrationApproved) {
                newState.viewMode = CUSTOMER_VIEW;
            }

            this.setState(newState)
        });
    }

    toggleTransactionModal() {
        this.setState({
            isCreatingTransaction: true
        });
    }

    toggleTransactionForBeneficiaryModal(requiredFields, beneficiary) {
        this.setState({
            isCreatingTransactionForExistingBeneficiary: true,
            transactionForBeneficiary: beneficiary,
            beneficiaryRequiredFields: requiredFields
        });
    }

    changeViewMode(event) {
        if (event !== null) {
            this.props.history.replace(this.baseUrl + "/" + event.view)
        }
        this.setState({
            viewMode: event !== null ? event.view : CUSTOMER_VIEW,
            viewModeId: event !== null ? event.id : 1
        })
    }

    onBackButtonClick() {
        this.props.history.push("/customer")
    }

    render() {
        return <Fragment>

            {this.state.isLoading ?
                <Fragment>
                    <br/>
                    <SFXLoadingComponent/>
                </Fragment>
                :
                <div className={"customerStatusDetails"}>
                    {this.renderAllCustomerData()}
                </div>
            }
            <div className={"customerStatusDetails"}>
                {this.state.isRequestingLimitIncrease && this.renderLimitIncreaseScreen()}
                {this.state.isCreatingTransaction && this.renderCreateTransactionScreen()}
                {this.state.isCreatingTransactionForExistingBeneficiary && this.renderCreateTransactionForBeneficiaryScreen()}
                {this.state.showIssueBankCardToCustomerModal && this.renderIssueBankCardToCustomerModal()}
                {this.state.showRequestBankAccountModal && this.renderRequestBankAccountModal()}
            </div>
        </Fragment>

    }

    renderHeader() {
        return <Fragment>
            <div style={{display: "flex", flex: 9}}>
                <Button onClick={this.onBackButtonClick.bind(this)} className={"fa fa-arrow-left"}
                        style={{
                            color: "#222c3d",
                            backgroundColor: "transparent",
                            backgroundRepeat: "no-repeat",
                            border: "none",
                            cursor: "pointer",
                            overflow: "hidden",
                            outline: "none",
                            fontSize: "20pt",
                            flex: 1,
                            textAlign: "left",
                            padding: 0,
                            paddingRight: "10px",
                            margin: "auto"
                        }}
                />
                <div style={{flex: 7, margin: "auto", fontSize: "1.2rem", fontWeight: "bold", textAlign: "center"}}>
                    {
                        this.state.isRegistrationApproved &&
                        <DropdownComponent
                            style={{marginBottom: "5px"}}
                            value={this.state.viewModeId}
                            options={CUSTOMER_VIEW_DROPDOWN_OPTIONS}
                            placeholder={"Select Data"}
                            onChange={this.changeViewMode}
                        />
                    }
                </div>
            </div>

            <br/>
        </Fragment>
    }

    renderAllCustomerData() {
        return <Fragment>
            <div style={{position: "sticky", top: 0, zIndex: 1, backgroundColor: "#fafafa", padding: "10px"}}>
                {this.renderHeader()}

            </div>


            {this.state.viewMode === CUSTOMER_VIEW && this.renderCustomerData()}

            {this.state.viewMode === CUSTOMER_LIMIT_VIEW && this.renderCustomerLimitData()}

            {this.state.viewMode === TRANSACTION_VIEW && this.renderTransactionData()}

            {this.state.viewMode === BENEFICIARY_VIEW && this.renderBeneficiaryData()}

        </Fragment>

    }

    renderCustomerData() {

        let buttonConfig = [];

        if (this.agentCanIssueBankCards && this.state.customer.canIssueBankCard && this.state.customer.approvalStatus === "Approved") {
            buttonConfig.push({
                buttonText: "Issue Bank Card",
                buttonFunction: this.issueBankCardToCustomer.bind(this)
            });
        }

        if (this.agentCanIssueBankAccounts && this.state.customer.canRequestBankAccount && this.state.customer.approvalStatus === "Approved") {
            buttonConfig.push({
                buttonText: "Request Bank Account",
                buttonFunction: this.requestBankAccount.bind(this)
            });
        }

        return <Fragment>
            {this.state.isLoading ? <SFXLoadingComponent/> :
                <Fragment>
                    <CardDeck>
                        <Card>
                            <CardBody>
                                <RegistrationStatusBadgeComponent
                                    status={this.state.registration.registrationStatus}
                                    statuses={Registration.badgeColours}
                                />

                                <hr/>

                                <CardDataComponent
                                    data={this.state.customer}
                                    config={CUSTOMER_CONFIG}
                                    buttonConfig={buttonConfig}
                                    bankAccountDetails={this.state.bankAccount}
                                />

                                {
                                    this.agentCanChat && this.state.canChatForCustomer &&
                                    this.renderChat()
                                }
                            </CardBody>

                        </Card>
                    </CardDeck>
                </Fragment>
            }
        </Fragment>

    }

    renderCustomerLimitData() {

        let buttonConfig = [{
            buttonText: "Request Increase",
            buttonFunction: this.requestLimitIncrease.bind(this)
        }];

        if (!this.agentCanRequestCustomerLimitIncrease) {
            buttonConfig = undefined;
        }

        return <Fragment>
            {this.agentCanViewCustomerLimits ? <Fragment>
                    <Card>
                        <CardHeader>
                            <h4 style={{flex: "5", fontWeight: "bold"}}>Customer Limit</h4>
                        </CardHeader>
                        <CardBody>
                            <CardDataComponent
                                data={this.state.customerLimit}
                                config={CUSTOMER_LIMIT_CONFIG}
                                buttonConfig={buttonConfig}
                            />
                        </CardBody>
                    </Card>
                </Fragment>
                :
                <Fragment>
                    {this.renderAccessDenied()}
                </Fragment>
            }
        </Fragment>

    }

    renderTransactionData() {
        return <Fragment>
            {this.agentCanViewCustomerTransactions ?
                <Fragment>
                    {(this.agentCanCreateTransactions && this.state.canTransactForCustomer) &&
                    <SFXButtonComponent
                        color={"primary"}
                        style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "10px",
                            marginBottom: "10px"
                        }}
                        onClick={this.toggleTransactionModal.bind(this)}>
                        Send Money
                    </SFXButtonComponent>
                    }
                    <TransactionCardDataComponent
                        canTransactForCustomer={this.state.canTransactForCustomer}
                        canChatForCustomer={this.state.canChatForCustomer}
                        transactions={this.state.transactions}
                        organisationsCanTransactIdsArrayIncludesAgentOrganisation={this.organisationsCanTransactIdsArrayIncludesAgentOrganisation}
                    />
                </Fragment>
                :
                <Fragment>
                    {this.renderAccessDenied()}
                </Fragment>
            }
        </Fragment>

    }

    renderBeneficiaryData() {
        return <Fragment>
            {this.agentCanViewCustomerBeneficiaries ?
                <Fragment>
                    <BeneficiaryCardDataComponent
                        customer={this.state.customer}
                        baseUrl={this.baseUrl + "/" + this.state.viewMode}
                        sendMoneyClick={(requiredFields, beneficiary) => this.toggleTransactionForBeneficiaryModal(requiredFields, beneficiary)}
                        agentCanCreateTransactions={this.agentCanCreateTransactions}
                        canTransactForCustomer={this.state.canTransactForCustomer}
                    />
                </Fragment>
                :
                <Fragment>
                    {this.renderAccessDenied()}
                </Fragment>
            }
        </Fragment>
    }

    renderLimitIncreaseScreen() {
        return <Fragment>
            <Modal isOpen={this.state.isRequestingLimitIncrease} className={"lg"}>
                <ModalHeader style={{backgroundColor: "#222c3d", color: "white"}}>Limit Increase</ModalHeader>
                <ModalBody>
                    <CustomerLimitIncreaseRequestComponent
                        registrationId={this.state.registrationId}
                        btnBackClick={() => {
                            this.setState({
                                isRequestingLimitIncrease: false
                            }, this.loadData)
                        }}
                    />
                </ModalBody>
            </Modal>
        </Fragment>
    }

    renderCreateTransactionScreen() {
        return <Fragment>
            <Modal isOpen={this.state.isCreatingTransaction} className={"lg"}>
                <ModalHeader style={{backgroundColor: "#222c3d", color: "white"}}>
                    <div>Create Transaction</div>
                </ModalHeader>
                <ModalBody>
                    <TransactionCreation
                        {...this.props}
                        btnBackClick={() => {
                            this.setState({
                                isCreatingTransaction: false
                            }, this.loadData)
                        }}
                    />
                </ModalBody>
            </Modal>
        </Fragment>
    }

    renderCreateTransactionForBeneficiaryScreen() {
        let beneficiary = this.state.transactionForBeneficiary;
        return <Fragment>
            <Modal isOpen={this.state.isCreatingTransactionForExistingBeneficiary} className={"lg"}>
                <ModalHeader style={{backgroundColor: "#222c3d", color: "white"}}>
                    <div>Create Transaction for {beneficiary.beneficiaryName}</div>
                </ModalHeader>
                <ModalBody>
                    <BeneficiaryTransactionCreation
                        {...this.props}
                        beneficiary={beneficiary}
                        beneficiaryRequiredFields={this.state.beneficiaryRequiredFields}
                        btnBackClick={() => {
                            this.setState({
                                isCreatingTransactionForExistingBeneficiary: false
                            }, this.loadData)
                        }}
                    />
                </ModalBody>
            </Modal>
        </Fragment>
    }

    renderIssueBankCardToCustomerModal() {
        return <Fragment>
            <Modal isOpen={this.state.showIssueBankCardToCustomerModal} className={"lg"}>
                <ModalHeader style={{backgroundColor: "#222c3d", color: "white"}}>Issue Bank Card</ModalHeader>
                <ModalBody>
                    <IssueBankCardComponent
                        registrationId={this.state.registrationId}
                        customer={this.state.customer}
                        btnCancelClick={() => {
                            this.setState({
                                showIssueBankCardToCustomerModal: false
                            }, this.loadData);
                        }}
                    />
                </ModalBody>
            </Modal>
        </Fragment>
    }

    renderRequestBankAccountModal() {
        return <Fragment>
            <Modal isOpen={this.state.showRequestBankAccountModal} className={"lg"}>
                <ModalHeader style={{backgroundColor: "#222c3d", color: "white"}}>Request Bank Account</ModalHeader>
                <ModalBody>
                    <RequestBankAccountComponent
                        registrationId={this.state.registrationId}
                        customer={this.state.customer}
                        btnCancelClick={() => {
                            this.setState({
                                showRequestBankAccountModal: false
                            }, this.loadData);
                        }}
                    />
                </ModalBody>
            </Modal>
        </Fragment>
    }

    renderAccessDenied() {
        return <Fragment>
            You do not have permissions to access this
        </Fragment>
    }

    renderChat() {

        return <Fragment>
            <ChatFromWithInContext
                resourceType={'REGISTRATION_ID'}
                resourceId={this.state.registrationId}
            />
        </Fragment>
    }
}

export default withRouter(CustomerIndex);
